module.exports = __webpack_public_path__ + "img/telegram_white.f369ad35.svg";